<template lang="pug">
v-system-bar(app height="40" color="grey")
  .container.text-center.text-subtitle-2.white--text {{ $t("архивная_касса") }}
</template>

<script>
const CURTAIN_CLASS = 're-deregistered-curtain'

export default {
  data: () => ({
    curtainElement: null,
  }),

  watch: {
    $route() {
      this.updateCurtain()
    },
  },

  mounted() {
    this.updateCurtain()
  },

  beforeDestroy() {
    this.removeCurtain()
  },

  methods: {
    // На архивной кассе раздел «Касса» закрывается занавесом - пробивать чеки нельзя
    updateCurtain() {
      if (this.$route.path === '/kkm') {
        this.createCurtain()
      } else {
        this.removeCurtain()
      }
    },

    createCurtain() {
      this.$nextTick(() => {
        const existingCurtains = document.querySelectorAll(`.${CURTAIN_CLASS}`)
        existingCurtains.forEach(curtain => curtain.remove())

        const curtain = document.createElement('div')
        curtain.classList.add(CURTAIN_CLASS)
        curtain.style.position = 'fixed'
        curtain.style.top = '0'
        curtain.style.left = '0'
        curtain.style.width = '100%'
        curtain.style.height = '100%'
        curtain.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'

        this.curtainElement = curtain

        const mainWrap = document.querySelector('.v-main__wrap')
        if (mainWrap) {
          mainWrap.appendChild(curtain)
        } else {
          document.body.appendChild(curtain)
        }
      })
    },

    removeCurtain() {
      if (this.curtainElement && this.curtainElement.parentNode) {
        this.curtainElement.remove()
      }
      this.curtainElement = null

      const allCurtains = document.querySelectorAll(`.${CURTAIN_CLASS}`)
      allCurtains.forEach(curtain => {
        curtain.remove()
      })
    },
  },
}
</script>
